import { createPatchAPI } from '@cuemath/rest-api';
import { BASE_V2_URL } from '../constants/api';

const { usePatch: useLearnosityItemUpdatePatch } = createPatchAPI({
  getURL: () => `${BASE_V2_URL}/questions/`,
});

export { useLearnosityItemUpdatePatch };
